"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.function.name");

var _cat = require("@/api/cat");

var state = {
  name: '',
  sex: ''
};
var mutations = {
  SET_NAME: function SET_NAME(state, name) {
    state.name = name;
  },
  SET_SEX: function SET_SEX(state, sex) {
    state.sex = sex;
  }
};
var actions = {
  edit: function edit(_ref, catInfo) {
    var commit = _ref.commit;
    var name = catInfo.name,
        sex = catInfo.sex;
    return new Promise(function (resolve, reject) {
      (0, _cat.edit)(catInfo).then(function (response) {
        var data = response.data;
        commit('SET_NAME', name);
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};
var _default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};
exports.default = _default;